(function() {
    'use strict';

    angular.module('order')
        .controller('OrderListController', OrderListController);

    OrderListController.$inject = [
        '$state',
        '$q',
        'searchFilterSrvc',
        'checkModelPermissionsSrvc',
        'orderDataSrvc',
        'orderSrvc',
        'orderStatusConst',
        'orderPaymentConst',
        'orderInvoice',
        'companyLocalizationConst',
        'datatableDefaultPageSizeValueConst',
        'checkSearchSrvc',
        'momentSrvc',
        'orderPermissionsConst',
        'downloadLinkSrvc',
        'dateFormatConst',
        'orderDeliveryStatusConst',
        'filterQuerySrvc',
        'siteDataSrvc',
        'notesDataSrvc',
        'tagsDataSrvc',
        'tagsPermissionsConst',
    ];

    function OrderListController(
        $state, $q, searchFilterSrvc, checkModelPermissionsSrvc, orderDataSrvc, orderSrvc, orderStatusConst,
        orderPaymentConst, orderInvoice, companyLocalizationConst, datatableDefaultPageSizeValueConst, checkSearchSrvc,
        momentSrvc, orderPermissionsConst, downloadLinkSrvc, dateFormatConst, orderDeliveryStatusConst, filterQuerySrvc,
        siteDataSrvc, notesDataSrvc, tagsDataSrvc, tagsPermissionsConst
    ) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.orderRows = [];
        self.orderCols = [{
            title: 'Nr zamówienia',
            value: 'pk&allegro_account_name&allegro_order_id&allegro_buyer_login',
            type: 'join',
            separator: '</br>',
            searchable: true,
            searchValue: 'pk',
            orderable: true,
            helpers: [{
                elementClass: 'fa fa-file table-helper-item',
                directTooltip: true,
                tooltip: 'Zawiera notatkę',
                typeClass: '',
                conditionProp: 'note_pk'
            }],
            popover: {
                title: 'Szczegóły notatki',
                templateUrl: 'app/notes/views/note-popovers/note-detail-popover.html',
                onInit: getOrderNote
            }
        }, {
            title: 'E-mail',
            value: 'client_email',
            type: 'link',
            linkTo: 'layout.client.details',
            linkParamProp: 'client_pk',
            orderValue: 'client__user__email',
            searchable: true,
            orderable: true
        }, {
            title: 'Klient',
            value: 'client_name',
            type: 'text',
            orderValue: 'client__user__first_name',
            searchable: true,
            orderable: true
        }, {
            title: 'Sklep',
            value: 'company_localization_display',
            type: 'text',
            orderValue: 'company_localization',
            searchable: true,
            orderable: true
        }, {
            title: 'Język',
            value: 'lang_display',
            type: 'text',
            orderValue: 'lang',
            searchable: true,
            orderable: true
        }, {
            title: 'Waluta',
            value: 'currency',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Netto',
            value: 'info.final_net_price',
            type: 'decimal'
        }, {
            title: 'Netto (bez wysyłki)',
            value: 'info.net_price_no_delivery',
            type: 'decimal'
        }, {
            title: 'Netto wysyłka',
            value: 'info.delivery_price',
            type: 'decimal',
            orderValue: 'delivery_price',
            searchValue: 'delivery_price',
            searchable: true,
            orderable: true
        }, {
            title: 'Stawka VAT',
            value: 'info.vat_percent',
            type: 'decimal',
            orderValue: 'vat_percent',
            searchValue: 'vat_percent',
            searchable: true,
            orderable: true
        }, {
            title: 'Wartość VAT',
            value: 'info.vat_price',
            type: 'decimal'
        }, {
            title: 'Liczba adresów',
            value: 'adresses_count',
            type: 'number',
            searchable: true,
            orderable: true
        }, {
            title: 'Liczba paczek',
            value: 'info.delivery_packages',
            type: 'number',
            orderValue: 'delivery_packages',
            searchValue: 'delivery_packages',
            searchable: true,
            orderable: true
        }, {
            title: 'Metoda płatności',
            value: 'payment_method_display',
            type: 'text',
            orderValue: 'payment_method',
            searchable: true,
            orderable: true
        }, {
            title: 'Status zamówienia',
            value: 'status_display',
            type: 'text',
            orderValue: 'status',
            searchable: true,
            orderable: true
        }, {
            title: 'Termin',
            value: 'realization_date',
            type: 'date',
            searchable: true,
            orderable: true
        }];
        self.modelPermissions = orderPermissionsConst;

        self.summaryCols = {
            'info.final_net_price': 'info.final_net_price_pln',
            'info.net_price_no_delivery': 'info.net_price_no_delivery_pln',
            'info.delivery_price': 'info.delivery_price_pln',
            'info.vat_price': 'info.vat_price_pln',
            'info.delivery_packages': 'info.delivery_packages',
        };

        self.logsInfo = [{
            title: 'Data dodania',
            value: 'date_added'
        }, {
            title: 'Data modyfikacji',
            value: 'date_modified'
        }, {
            title: 'Edytowano przez',
            value: 'last_modified_by'
        }];

        self.extraActions = [{
            class: 'btn btn-primary btn-xs',
            iconClass: 'fa fa-file-pdf-o',
            title: 'Pobierz kartę',
            onClick: function(row) {
                return orderSrvc.getOrderCard(row);
            }
        }];

        self.contextMenu = [{
            text: 'Zapłacono',
            displayed: hasOrderUpdatePermissions,
            enabled: function($itemScope, $event, modelValue) {
                return !orderSrvc.isDisablePaid($itemScope.row);
            },
            click: function ($itemScope, $event, modelValue, text, $li) {
                return orderSrvc.payAnOrder($itemScope.row);
            }
        }, {
            text: 'Zakończ zamówienie',
            displayed: hasOrderUpdatePermissions,
            enabled: function($itemScope, $event, modelValue) {
                return !orderSrvc.isDisableCompleted($itemScope.row);
            },
            click: function ($itemScope, $event, modelValue, text, $li) {
                return orderSrvc.completeAnOrder($itemScope.row);
            }
        }, {
            text: 'Anuluj zamówienie',
            displayed: hasOrderUpdatePermissions,
            enabled: function($itemScope, $event, modelValue) {
                return !orderSrvc.isDisableCanceled($itemScope.row);
            },
            click: function ($itemScope, $event, modelValue, text, $li) {
                return orderSrvc.cancelAnOrder($itemScope.row);
            }
        }];

        self.searchQuery = {
            pk: null,
            client_email: null,
            client_name: null,
            company_localization_display: null,
            currency: null,
            lang_display: null,
            vat_percent: null,
            adresses_count: null,
            delivery_packages: null,
            delivery_price: null,
            payment_method_display: null,
            status_display: null,
            realization_date: null,
            ordering: null
        };

        self.dateFormat = dateFormatConst.datePickerWithoutDay;
        self.maxDate = momentSrvc.dateToStr(momentSrvc.getCurrentDate());
        self.filterData = {
            date: self.maxDate,
            payment_status: [],
            invoice_paper: [],
            status: [
                orderStatusConst.in_realization.value,
                orderStatusConst.in_production.value
            ],
            delivery_status: [],
            company_localization: [],
            source: null,
            site_pk: null,
            has_notes: null,
            notes_text: null,
            tag_pks: null
        };

        self.orderStatusesFilter = Object.keys(orderStatusConst).map(function(key) {
            return orderStatusConst[key];
        });

        self.orderDeliveryStatusFilter = Object.keys(orderDeliveryStatusConst).map(function(key) {
            return orderDeliveryStatusConst[key];
        });

        self.orderPaymentsFilter = Object.keys(orderPaymentConst).map(function(key) {
            return orderPaymentConst[key];
        });

        self.companyLocalizations = companyLocalizationConst;

        self.orderInvoice = Object.keys(orderInvoice).map(function(key) {
            return orderInvoice[key];
        });

        self.sourceOptions = [
            { value: 'internal', title: 'Wewnętrzne' },
            { value: 'external', title: 'Zewnętrzne' },
            { value: 'allegro', title: 'Allegro'}
        ];

        self.hasNotesOptions = [
            { value: true, title: 'Tak' },
            { value: false, title: 'Nie' }
        ];

        self.exposingData = {
            color: {
                'payment_deadline_overdued': '#f8c1c1',
            },
            conditionProp: 'exposing_value',
            conditionValue: ['payment_deadline_overdued']
        };

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        self.onClick = onClick;
        self.onCreate = onCreate;
        self.changeFilter = changeFilter;

        self.isCanDisplaySites = false;
        self.siteOptions = [];
        self.initSiteOption = initSiteOption;

        self.isCanDisplayTags = false;
        self.tagOptions = [];

        activate();

        function activate() {
            self.isCanDisplaySites = canDisplaySites();
            self.isCanDisplayTags = canDisplayTags();
            self.filterData = filterQuerySrvc.initializeFilterData(self.filterData);
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();

            loadFieldOptions()
        }

        function loadFieldOptions(){
            return $q.all([getSiteOptions(), getTagOpts()]).then(
                function(response) {
                    getOrders()
                }
            ).catch(
                function(error) {
                    console.log(error)
                }
            )
        }

        function getOrders(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,

                    pk: self.searchQuery.pk,
                    client_email: self.searchQuery.client_email,
                    client_name: self.searchQuery.client_name,
                    company_localization_display: self.searchQuery.company_localization_display,
                    currency: self.searchQuery.currency,
                    lang_display: self.searchQuery.lang_display,
                    vat_percent: self.searchQuery.vat_percent,
                    adresses_count: self.searchQuery.adresses_count,
                    delivery_packages: self.searchQuery.delivery_packages,
                    delivery_price: self.searchQuery.delivery_price,
                    payment_method_display: self.searchQuery.payment_method_display,
                    status_display: self.searchQuery.status_display,
                    realization_date: searchFilterSrvc.getDateValue(self.searchQuery.realization_date),

                    date_year: self.filterData.date ?
                        momentSrvc.dateYear(self.filterData.date) : null,
                    date_month: self.filterData.date ?
                        momentSrvc.dateMonth(self.filterData.date) : null,
                    payment_status: self.filterData.payment_status,
                    status: self.filterData.status,
                    delivery_status: self.filterData.delivery_status,
                    invoice_paper: self.filterData.invoice_paper,
                    company_localization: self.filterData.company_localization,
                    source: self.filterData.source,
                    site_pk: self.filterData.site_pk,
                    has_notes: self.filterData.has_notes,
                    notes_text: self.filterData.notes_text,
                    tag_pks: self.filterData.tag_pks,
                };
            }
            return orderDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.orderRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getOrders);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function hasOrderUpdatePermissions() {
            return !checkModelPermissionsSrvc.isDenied(
                orderPermissionsConst.update);
        }

        function changeFilter() {
            filterQuerySrvc.updateFilterData(self.filterData);
            filterQuerySrvc.setLocationParams();
            return getOrders();
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getOrders();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getOrders();
        }

        function onClick(row) {
            var match_pk = row.pk.toString().match(/(\d+)/);
            var pk = row.pk;
            if (match_pk.length){
                pk = match_pk[0];
            }
            $state.go('layout.order.details', { pk: pk });
        }

        function onCreate() {
            $state.go('layout.order.create');
        }

        function initSiteOption(){
            for (var index in self.siteOptions) {
                var optionPk = self.siteOptions[index].pk
                if (optionPk === config.siteId && self.filterData.site_pk === null){
                    self.filterData.site_pk = optionPk;
                }
            }
        }

        function getSiteOptions() {
            if (self.isCanDisplaySites) {
                var siteIds = checkModelPermissionsSrvc.getPermittedSiteIds(orderPermissionsConst.view)
                return siteDataSrvc.getFieldOpts({"ids": siteIds}).$promise.then(
                    function(response) {
                        self.siteOptions = response.results;
                        initSiteOption();
                    });
            }
        }

        function canDisplaySites() {
            var ids = checkModelPermissionsSrvc.getPermittedSiteIds(orderPermissionsConst.view)
            return ids.length > 1;
        }

        function getOrderNote($event, order) {
            $event.stopPropagation();
            return notesDataSrvc.get({pk: order.note_pk}).$promise.then(
                function (response) {
                    order['note'] = response.toJSON();
                    return response;
                }
            )
        }

        function canDisplayTags() {
            return !checkModelPermissionsSrvc.isDenied(tagsPermissionsConst.view);
        }

        function getTagOpts(){
            if (self.isCanDisplayTags) {
                return tagsDataSrvc.getFieldOpts().$promise.then(
                    function (response) {
                        self.tagOptions = response;
                    });
            }
        }
    }
})();
